import type { Module, Resource, Services } from 'i18next';

class LocalazyBackend implements Module {
    type: 'backend';

    services: Services;

    baseApiUrl: string;

    token: string;

    projectId: string;

    fileId: string;

    constructor(services: Services) {
        this.type = 'backend';
        this.services = services;
        this.baseApiUrl = process.env.GATSBY_LOCALAZY_API_URL || '';
        this.token = process.env.GATSBY_LOCALAZY_TOKEN || '';
        this.projectId = process.env.GATSBY_LOCALAZY_PROJECT_ID || '';
        this.fileId = process.env.GATSBY_LOCALAZY_FILE_ID || '';
        this.init(services);
    }

    init(services: Services) {
        this.services = services;
    }

    async fetchTranslations(language: string): Promise<Resource> {
        try {
            const response = await fetch(`${this.baseApiUrl}/projects/${this.projectId}/files/${this.fileId}/download/${language}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${this.token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Error fetching translations files: ${response.statusText}`);
            }

            const translations = await response.json();

            return translations;
        } catch (error) {
            console.error('Error fetching translation files:', error);
            return {};
        }
    }

    async read(language: string, namespace: string, callback: (error: unknown, result: Resource) => void) {
        try {
            const resources = await this.fetchTranslations(language);

            callback(null, resources);
        } catch (error) {
            callback(error, {});
        }
    }
}

export default LocalazyBackend;
